import { styled } from '@mui/material/styles';
import React from 'react';
import { Typography } from '@mui/material';
import classNames from 'classnames';

import { Padding } from '@lialo/pwa-ui/lib/Padding';


const PREFIX = 'EmptyPageNotice';

const classes = {
  grow: `${PREFIX}-grow`,
  center: `${PREFIX}-center`,
};

const StyledPadding = styled(Padding)((
  {
    theme,
  },
) => ({
  [`&.${classes.grow}`]: {
    flexGrow: 1,
  },

  [`&.${classes.center}`]: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    flexDirection: 'column',
  },
}));


interface IProps {
  line1: React.ReactNode;
  line2: React.ReactNode;
  children?: React.ReactNode;
}

export const EmptyPageNotice = (props: IProps) => {


  return (
    <StyledPadding spacingY={0} className={classNames(classes.grow, classes.center)}>
      <div>
        <Typography variant={'body1'}>{props.line1}</Typography>
        <Typography variant={'body2'}>{props.line2}</Typography>
        {props.children}
      </div>
    </StyledPadding>
  );
};
